
const moduleData = {
  id: "module-9",
  title: "Module 9",
  subtitle: "Seeing God everywhere through the path of Jnana Marga in संन्यास(saṃnyāsa)  Āśrama",
   cardImage: "/enBanner/m9_banner.jpeg",
  pdfPath: "/en/Modules/m9.pdf",
  audio: {
    title: "Vedic Chanting - Placeholder",
    audioUrl: "/en/Audio/m9.mp3",
    duration: "0:00"
  },
  video: {
    id: "g-g1_2_g_0k"
  },
  hero: {
    title: "Module 9",
    subtitle: "Seeing God everywhere through the path of Jnana Marga in संन्यास(saṃnyāsa)  Āśrama",
    description: "Content for this module is coming soon.",
    buttonText: "Explore",
    bgImage: "/enBanner/m9_banner.jpeg",
    bgAlt: "Placeholder"
  },
  pages: [
    {
      pageId: 'definition',
      title: 'Definition',
      definition: {
        sectionLabel: "Definition",
        title: "What is Seeing God everywhere through the path of Jnana Marga in संन्यास(saṃnyāsa)  Āśrama?",
        text: "Placeholder text.",
        quote: {
          sanskrit: "",
          meaning: "",
          origin: ""
        },
        description: "Placeholder description.",
        source: "",
        image: "",
        imageAlt: ""
      }
    },
    {
      pageId: 'quiz',
      title: 'Quiz',
      quiz: {
        questions: [
          {
            question: "What is the true meaning of Sanyasa?",
            options: ["Wearing ochre robes and shaving the head", "Giving up all desires and performing activities as an offering to the Lord", "Avoiding joy and grief", "Attaining liberation through inactivity"],
            answer: "Giving up all desires and performing activities as an offering to the Lord"
          },
          {
            question: "What is the significance of Viraja Homa in Sanyasa?",
            options: ["It signifies the beginning of a new worldly life", "It signifies the person's death to their previous worldly commitments", "It is a ritual to attain wealth", "It is a celebration of success"],
            answer: "It signifies the person's death to their previous worldly commitments"
          },
          {
            question: "Which type of Sanyasa involves giving up all Sankalpas (resolutions, desires)?",
            options: ["Deha Sannyasa", "Mano Sannyasa", "Atma Sannyasa", "Karma Sannyasa"],
            answer: "Mano Sannyasa"
          },
          {
            question: "Sannyāsa Āśrama is primarily associated with which life goal?",
            options: ["Dharma", "Artha", "Kāma", "Mokṣa"],
            answer: "Mokṣa"
          },
          {
            question: "What are the three things emphasized by Vedanta for spiritual progress?",
            options: ["Wealth, fame, and power", "Shravana, Manana, and Nididhyasana", "Rituals, sacrifices, and offerings", "Meditation, isolation, and silence"],
            answer: "Shravana, Manana, and Nididhyasana"
          },
          {
            question: "How many principal Mahāvākyas are traditionally accepted?",
            options: ["Two", "Three", "Four", "Five"],
            answer: "Four"
          },
        ]
      }
    },
    {
      pageId: 'feedback',
      title: 'Feedback',
      feedback: {}
    }
  ]
};

export { moduleData };
